import * as yup from 'yup';

export const addressSchema = yup
  .object()
  .shape({
    cityId: yup.string().required(),
    addressId: yup.string().notRequired(),
    addressType: yup.string().oneOf(['Apartment', 'Villa', 'Office', 'Hotel']).required(),
    lng: yup.string().required('Please select a location'),
    lat: yup.string().required('Please select a location'),
    geofenceLabel: yup.string().required(),
    geofenceId: yup.string().required(),
    notes: yup.string(),
    addressText: yup.string().when('addressType', {
      is: (value: string) => ['Apartment', 'Hotel', 'Office'].indexOf(value) >= 0, // alternatively: (val) => val == true
      then: (schema) => schema.required('Please enter the building name.'),
    }),
    number: yup.string().when('addressType', {
      is: (value: string) => ['Apartment', 'Hotel', 'Office'].indexOf(value) >= 0, // alternatively: (val) => val == true
      then: (schema) => schema.required('Please enter the number.'),
    }),
    street: yup.string().when('addressType', {
      is: 'Villa', // alternatively: (val) => val == true
      then: (schema) => schema.required('Please enter the steet name.'),
    }),
    villa: yup.string().when('addressType', {
      is: 'Villa', // alternatively: (val) => val == true
      then: (schema) => schema.required('Please enter the villa name.'),
    }),
    lastAddressUsed: yup.boolean(),
    placeId: yup.string(),
  })
  .required();

export type AddressForm = yup.InferType<typeof addressSchema>;
